import React from "react";
import * as PropTypes from "prop-types";
import { managedLabeledValuePropType } from "../../propTypes";
import Button from "@mui/material/Button";
import { withTranslation } from "react-i18next";
import ManageDataTableRuns from "./ManageDataTableRuns";

const styles = {
    buttonGroup: {
        marginTop: 20,
    },
};

const ManageDataRuns = ({ t, ...rest }) => {
    const disabled =
        !rest.selectedRunIds.length ||
        rest.runs.filter((run) => rest.selectedRunIds.includes(run.value) && run.isGlobal).length > 0;

    return (
        <div>
            <ManageDataTableRuns
                items={rest.runs}
                selectedItemValues={rest.selectedRunIds}
                onToggleItem={rest.onToggleRun}
            />

            <div style={styles.buttonGroup}>
                <Button
                    variant="contained"
                    color="secondary"
                    disabled={disabled}
                    onClick={rest.onDeleteRuns}
                >
                    {t("Delete selected runs")}
                </Button>
            </div>
        </div>
    );
};

ManageDataRuns.propTypes = {
    runs: PropTypes.arrayOf(managedLabeledValuePropType),
    selectedRunIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    onToggleRun: PropTypes.func.isRequired,
    onDeleteRuns: PropTypes.func.isRequired,
};

ManageDataRuns.defaultProps = {
    runs: [],
};

export default withTranslation()(ManageDataRuns);
